﻿export { SearchLocation };
import { transform, transformExtent } from 'ol/proj';
import { extend } from '../../chart.js/dist/Chart';

/**
 * Class SearchLocation
 */
const SearchLocation = function () {
    // Define this
    var mySearchLocation = this;

    // -- begin private variable ------------------------------------------------------------------

    // sorting criteria
    this.sortCriteria = [
        ['rank', 'desc']
        //['score', 'desc'],
        //['attributes.Region', 'asc'],
        //['attributes.Subregion', 'asc'],
        //['attributes.City', 'asc'],
        //['area', 'asc']
    ];


    this._ui = {
        containerSelector: null,
        containerElement: null,
        resultContainerElement: null
    };

    this._locationConfig = {
        maxZoom: 13,
        flyToDuration: 4000
    };

    // 
    this._mapSgs = null;

    // timeout instance that maintains the delay between the keydown event and the search in the API
    this._debounceTimeout;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Search location api esri
     * @param {any} searchString
     */
    this.Search = function (searchString) {
        return this._apiInstance instanceof BasePlaceSearch ? this._apiInstance.search(searchString) : new Promise((resolve, reject) => reject(new Error("A instância de acesso à API não está correta")));
    }

    /**
     * show or hide the functionality
     * */
    this.ToogleSearchLocation = function () {

        const inputElement = mySearchLocation._GetElement('inputSearch');

        if (!inputElement) {
            mySearchLocation._CreateInterface();
        }

        const containerElement = mySearchLocation._GetElement('container');

        if (containerElement) {
            containerElement.toggle(300, function () {

                if (containerElement.is(':visible')) {
                    mySearchLocation.ClearSearch();

                    if (mySearchLocation._mapSgs._utility.mobilecheck()) {
                        containerElement.css({ 'width': '70%' });
                        containerElement.css({ 'left': '66px' });
                        containerElement.css({ 'top': '15px' });
                    } else {
                        containerElement.css({ 'width': '300px' });
                        containerElement.css({ 'left': '35%' });
                    }
                } else {
                    if (mySearchLocation._mapSgs._utility.mobilecheck()) {
                        containerElement.css({ 'width': '0%' });
                        containerElement.css({ 'left': '25px' });
                        containerElement.css({ 'top': '15px' });
                    } else {
                        containerElement.css({ 'width': '0px' });
                        containerElement.css({ 'left': '35%' });
                    }
                }
            });
        }
    }

    /**
     * clear the search performed
     * */
    this.ClearSearch = function () {
        // clear input search
        const inputSearchElement = mySearchLocation._GetElement('inputSearch');

        if (inputSearchElement)
            inputSearchElement.val('');

        mySearchLocation.ClearResults();
    }

    /**
     * clear the results list
     * */
    this.ClearResults = function () {
        // delete previous search results
        const resultListElement = mySearchLocation._GetElement('resultList');

        if (resultListElement)
            resultListElement.empty();

        // hide search results container
        mySearchLocation._HideElement('resultContainer');
    }


    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * create the interface of the functionality
     * */
    this._CreateInterface = function () {

        const containerElement = mySearchLocation._GetElement('container');

        if (containerElement.length) {

            containerElement.empty();

            containerElement.append(
                `<input id="${mySearchLocation._ui.inputSearch.id}" class="form-control form-control-sm" type="text" placeholder="Local">` +
                `<span id="${mySearchLocation._ui.btnClear.id}">×</span>` +
                `<div id="${mySearchLocation._ui.resultContainer.id}"><div id="${mySearchLocation._ui.resultList.id}"></div></div>`
            );

            // register events
            // input search register keydown event
            const inputSearchElement = mySearchLocation._GetElement('inputSearch');

            if (inputSearchElement) {
                // event on keydown on input for search location api esri
                inputSearchElement.keydown((event) => {
                    if (event.key === 'Enter') {
                        mySearchLocation._Search(event.target.value);
                    } else {
                        // maintain a delay between the keydown event and the search being performed
                        clearTimeout(mySearchLocation._debounceTimeout);
                        mySearchLocation._debounceTimeout = setTimeout(() => {
                            mySearchLocation._Search(event.target.value);
                        }, 300); // 300 ms delay
                    }
                });
            }

            // btn clear search register click event
            const btnClearElement = mySearchLocation._GetElement('btnClear');

            if (btnClearElement) {
                btnClearElement.on('click', mySearchLocation.ClearSearch);
            }
        }
    }

    /**
     * Search location api esri
     * @param {any} searchString
     */
    this._Search = function (searchString) {

        if (searchString.trim() == '') {
            mySearchLocation.ClearSearch();
        } else {

            const resultListElement = mySearchLocation._GetElement('resultList');

            if (resultListElement) {

                // specify the search projection
                mySearchLocation._apiInstance.config.outSR = mySearchLocation._mapSgs.map.getView().getProjection().code_.split(':')[1];
                // mySearchLocation._apiInstance.config.outSR = mySearchLocation._mapSgs._settings._mapSettings.map_info.srs_srid.toString();

                // run search
                mySearchLocation.Search(searchString).then((response) => {

                    // if it returns results
                    if (response && response.success) {

                        // remove old results
                        resultListElement.empty();

                        const outSR = response.data.spatialReference.wkid;

                        if (response.data.candidates && response.data.candidates.length) {

                            // check if they have sorting criteria for the results
                            if (mySearchLocation.sortCriteria && mySearchLocation.sortCriteria.length) {
                                // sort the results by the established criteria
                                response.data.candidates.sort((candidateA, candidateB) => {
                                    // evaluate the different sorting criteria
                                    for (const criterion of mySearchLocation.sortCriteria) {

                                        const [key, order] = criterion;

                                        let valueA, valueB = null;

                                        switch (key) {
                                            // evaluate criterion area
                                            case 'area':
                                                valueA = (candidateA.extent.xmax - candidateA.extent.xmin) * (candidateA.extent.ymax - candidateA.extent.ymin);
                                                valueB = (candidateB.extent.xmax - candidateB.extent.xmin) * (candidateB.extent.ymax - candidateB.extent.ymin);
                                                break;
                                            default:
                                                const valuePath = key.split('.');

                                                valuePath.map((path) => {
                                                    valueA = valueA ? valueA[path] : candidateA[path];
                                                    valueB = valueB ? valueB[path] : candidateB[path];
                                                });
                                                break;
                                        }

                                        if (valueA !== valueB) {
                                            return order === 'asc' && valueA < valueB ? -1 : 1;
                                        }
                                    }
                                    return 0; // equality in all criteria
                                });
                            }

                            // display results in the interface
                            response.data.candidates.map((candidate) => {

                                // build subtitle
                                const subTitleArray = [];

                                ['zipCode', 'subRegion', 'region'].map(key => candidate[key] ? subTitleArray.push(candidate[key]) : '');

                                // build data element
                                // return number with two decimal places
                                const truncNum = (value, decimals) => Math.trunc(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

                                const coordDecimals = 6;
                                // srid of the coordinates
                                const attSrid = `data-srid="${outSR}"`;
                                // extent of the candidate
                                const attrExtent = `data-extent="${truncNum(candidate.extent.xmin, coordDecimals)},${truncNum(candidate.extent.ymin, coordDecimals)},${truncNum(candidate.extent.xmax, coordDecimals)},${truncNum(candidate.extent.ymax, coordDecimals)}"`;
                                // coordinate of the candidate
                                const attrCoord = `data-coordenate="${candidate.location.lng},${candidate.location.lat}"`;
                                // type of location
                                const attrTypeLocation = `data-type-location="${candidate.type}"`;

                                // create item
                                const resultItemElement = $(`<div class="${mySearchLocation._ui.resultListItem.class}" ${attrTypeLocation} ${attSrid} ${attrCoord} ${attrExtent}">` +
                                    `<div class="title">${candidate.name}</div>` +
                                    `<div class="subtitle"><span>${subTitleArray.join(', ')}</span><span>${candidate.category}</span></div>` +
                                    '<div class="score">' +
                                    `<progress value="${candidate.score}" max="100" class="score-bar"></progress>` +
                                    '</div>' +
                                    '</div>');

                                // add item to list
                                resultListElement.append(resultItemElement);
                            });

                            // check if the click event has already been registered for the item element
                            const managementEvents = jQuery._data($(`.${mySearchLocation._ui.resultListItem.class}`)[0], 'events');

                            if (!managementEvents || !managementEvents.click) {

                                // result item list register click event
                                $(`.${mySearchLocation._ui.resultListItem.class}`).on('click', (event) => {

                                    const dataSrid = event.currentTarget.getAttribute('data-srid');
                                    const currentProjMap = mySearchLocation._mapSgs.map.getView().getProjection().code_.split(':')[1];

                                    let dataCenter = null;
                                    const dataTypeLocation = event.currentTarget.getAttribute('data-type-location');

                                    switch (dataTypeLocation.toLowerCase()) {
                                        case 'point':
                                            dataCenter = event.currentTarget.getAttribute('data-coordenate').split(',').map((value) => parseFloat(value));

                                            if (dataSrid != currentProjMap) {
                                                // reproject coordinate
                                                dataCenter = transform(
                                                    dataCenter,
                                                    `EPSG:${dataSrid}`, // extent reference system
                                                    `EPSG:${currentProjMap}`  // map reference system
                                                )
                                            }
                                            break;
                                        case 'line':
                                        case 'polygon':
                                            // [minX, minY, maxX, maxY]
                                            let dataExtent = event.currentTarget.getAttribute('data-extent').split(',').map((value) => parseFloat(value));

                                            if (dataSrid != currentProjMap) {
                                                // reproject coordinate
                                                dataExtent = transformExtent(
                                                    dataExtent,
                                                    `EPSG:${dataSrid}`, // extent reference system
                                                    `EPSG:${currentProjMap}`  // map reference system
                                                )
                                            }
                                            dataCenter = dataExtent;
                                            break;
                                        default:
                                            break;
                                    }

                                    mySearchLocation._FlyTo(dataCenter);
                                });
                            }

                            // show result container
                            mySearchLocation._ShowElement('resultContainer');
                        } else {
                            mySearchLocation.ClearResults();
                        }
                    } else {
                        mySearchLocation.ClearResults();
                        toastr["error"]("Não foi possível obter os resultados da pesquisa");
                    }
                }).catch((error) => {
                    mySearchLocation.ClearResults();
                    toastr["error"](error instanceof ErrorSearch ? error.message : "Não foi possível obter os resultados da pesquisa");
                });
            }
        }
    }

    /**
     * centers the map on a specific location
     * @param {any} location
     */
    this._FlyTo = (location) => {

        if (location) {

            const duration = mySearchLocation._locationConfig.flyToDuration;
            const view = mySearchLocation._mapSgs.map.getView();
            const zoom = view.getZoom();
            const deltaZoom = zoom == mySearchLocation._locationConfig.maxZoom ? 1 : 1;

            // if extent
            if (location.length == 4) {
                view.fit(location, {
                    padding: [20, 20, 20, 20],                                           // add space around the area
                    maxZoom: mySearchLocation._locationConfig.maxZoom,                   // maximum zoom level
                    duration: duration                                                   // animation duration
                });
            } else {
                view.animate({
                    center: location,
                    duration: duration
                });
            }

            view.animate({
                zoom: zoom - deltaZoom,
                duration: duration / 2
            }, {
                zoom: mySearchLocation._locationConfig.maxZoom,
                duration: duration / 2
            });
        }
    }

    /**
     * search for an element
     * @param {any} elementName
     */
    this._GetElement = function (elementName) {
        if (mySearchLocation._ui[elementName]) {
            if (!mySearchLocation._ui[elementName].hasOwnProperty('element') || !mySearchLocation._ui[elementName].element || !mySearchLocation._ui[elementName].element.length) {
                mySearchLocation._ui[elementName]['element'] = $(`#${mySearchLocation._ui[elementName].id}`);
            }
            if (mySearchLocation._ui[elementName].element.length) {
                return mySearchLocation._ui[elementName].element;
            }
        }
        return null;
    }

    /**
     * show element
     * @param {any} elementName
     */
    this._ShowElement = function (elementName) {
        const element = mySearchLocation._GetElement(elementName);

        if (element)
            element.slideDown(400);
    }

    /**
     * hide element
     * @param {any} elementName
     */
    this._HideElement = function (elementName) {
        const element = mySearchLocation._GetElement(elementName);

        if (element)
            element.slideUp(400);
    }

    // -- end private method ----------------------------------------------------------------------
};

/**
 * Init Search Location
 * @param {any} idContainer
 * @param {any} MapSgs
 * @param {any} apiConfig
 * 
 */
SearchLocation.prototype.InitSearchLocation = function (idContainer, MapSgs, apiConfig) {

    const containerElement = $(`#${idContainer}`);

    if (!containerElement.length) {

    } else {
        this._ui.container = { element: containerElement };
        this._ui.inputSearch = { id: 'id-search-location-api-input' };
        this._ui.btnClear = { id: `${this._ui.inputSearch.id}-clear-btn` };

        this._ui.resultContainer = { id: 'id-search-location-api-results' };
        this._ui.resultList = { id: `${this._ui.resultContainer.id}-list` };
        this._ui.resultListItem = { class: 'search-location-api-results-list-item' };

        // keep map sgs
        this._mapSgs = MapSgs;

        switch (apiConfig.api) {
            case 'googleGeocode':
                this._apiInstance = new GoogleGeocodeSearch(apiConfig.params);
                break;
            case 'google':
                this._apiInstance = new GooglePlaceSearch(apiConfig.params);
                break;
            case 'esri':
                this._apiInstance = new EsriPlaceSearch(apiConfig.params);
                break;
            default:
                throw new Error("API não suportada");
        }
    }
};


class BasePlaceSearch {
    /**
     * @param {Object} config - API-specific configuration
     */
    constructor(config) {
        this.defineApiParams = null;
        this.config = config;
    }

    setConfig(objConfig) {

    }

    /**
     * 
     * @param {any} param
     * @param {any} value
     */
    setParam(param, value) {
        if (this.defineApiParams && this.defineApiParams.hasOwnProperty(param)) {
            this.config[param] = value;
        }
    }

    /**
     * Abstract method that should return the URL to perform the search
     * @param {String} query - Search text
     */
    getUrl(query) {
        throw new Error("O método getUrl deve ser implementado");
    }

    /**
     * Abstract method to process the API result and normalize it
     * @param {Object} data - Raw API response.
     */
    processResult(data) {
        throw new Error("O método processResult deve ser implementado");
    }

    /**
     * Perform the search: build the URL, query the API, and return normalized results
     * @param {String} query - Search text
     * @returns {Promise<Array>} - Array with normalized objects
     */
    search(searchString) {
        return new Promise(async (resolve, reject) => {

            try {
                let resultObj = {
                    success: true,
                    data: { candidates: [], spatialReference: null }
                };

                if (!searchString.trim() == '') {

                    const url = this.getUrl(searchString);
                    const response = await fetch(url);

                    if (!response.ok) {
                        reject(new Error("Falha na solicitação da API"));
                    }

                    const data = await response.json();

                    resultObj.data = this.processResult(data);
                }

                resolve(resultObj);
            } catch (e) {
                reject(e);
            }
        });
    }
}



class GoogleGeocodeSearch extends BasePlaceSearch {

    constructor(config) {
        super(config);

        this.defaultProjection = 4326;

        // translation of some types of elements
        this._attrType = {
            'street_address': 'Endereço',
            'route': 'Rua',
            'intersection': 'Interseção',
            'political': 'Administração pública',
            'country': 'País',
            'administrative_area_level_1': 'Distrito',
            'administrative_area_level_2': 'Concelho',
            'administrative_area_level_3': 'Freguesia',
            'locality': 'Localidade',
            'neighborhood': 'Área residencial',
            'premise': 'Prédio',
            'postal_code': 'Código postal',
            'airport': 'Aeroporto',
            'park': 'Parque',
            'parking': 'Estacionamento',
            'point_of_interest': 'Ponto interesse',
            'bus_station': 'Estação de autocarros',
            'train_station': 'Estação de comboio',
            'transit_station': 'Estação de trânsito'
        };

        this.defineApiParams = {
            key: { required: true, default: null },           // [Required]: Access key with the required privileges
            address: null,                                    // [Optional]: Address you want to geocode
            latlng: null,                                     // [Optional]: Latitude and longitude coordinates for reverse geocoding
            place_id: null,                                   // [Optional]: Unique identifier of a place to obtain its address
            components: null,                                 // [Optional]: Filter to restrict results to certain components [ Example: country, postal code ]
            bounds: null,                                     // [​Optional]: Defines a bounding box to skew results toward a specific region
            region: null,                                     // [​Optional]: Biases results toward a particular country or region
            language: null,                                   // [Optional]: Specifies the language in which the results are returned
        };
    }

    getUrl(query) {

        const sendParams = { sensor: false };

        for (let key in this.config) {
            if (this.config.hasOwnProperty(key) && this.config[key] != null && this.config[key] != undefined) {
                switch (key) {
                    case 'outSR':
                        break;
                    case 'latlng':
                        debugger
                        if (this.config['outSR'] && this.config['outSR'] != this.defaultProjection) {
                            const coord = this.config[key].split(',').map(item => parseFloat(item));
                            // reproject coordinate
                            const latlng = transform(
                                coord,
                                `EPSG:${this.config['outSR']}`, // extent reference system
                                `EPSG:${this.defaultProjection}`  // map reference system
                            )
                            sendParams[key] = latlng.join(',');
                        }
                        break;
                    case 'bounds':
                        if (this.config['outSR'] && this.config['outSR'] != this.defaultProjection) {
                            const bounds = this.config[key].split(',').map(item => parseFloat(item));
                            // reproject coordinate
                            const extent = transformExtent(
                                bounds,
                                `EPSG:${this.config['outSR']}`, // extent reference system
                                `EPSG:${this.defaultProjection}`  // map reference system
                            );
                            sendParams[key] = extent.join(',');
                        }
                        break;
                    default:
                        sendParams[key] = this.config[key];
                        break;
                }
            }
        }
        sendParams['address'] = query;

        const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json";
        return `${baseUrl}?${new URLSearchParams(sendParams).toString()}`;
    }

    processResult(response) {
        switch (response.status) {
            case 'OVER_DAILY_LIMIT':
                throw new ErrorSearch("Problemas de acesso à API");
                break;
            case 'OVER_QUERY_LIMIT':
                throw new ErrorSearch("A quota foi excedida");
                break;
            case 'REQUEST_DENIED':
                throw new ErrorSearch("Pedido rejeitado pela API");
                break;
            case 'INVALID_REQUEST':
                throw new ErrorSearch("Pedido inválido");
                break;
            case 'UNKNOWN_ERROR':
                throw new ErrorSearch("O pedido não pôde ser processado devido a um erro no servidor. A solicitação poderá ser concluída com êxito se tentar novamente");
                break;
            default:
        }
        return {
            candidates: (response.results || []).map((candidate, index) => {

                const scoreLocationType = { 'ROOFTOP': 100, 'RANGE_INTERPOLATED': 85, 'GEOMETRIC_CENTER': 65, 'APPROXIMATE': 35 };

                let category = '----';

                candidate.types.some((type) => {
                    if (this._attrType.hasOwnProperty(type)) {
                        category = this._attrType[type];
                        return true;
                    }
                    return false;
                });

                const result = {
                    name: candidate.formatted_address,
                    address: candidate.formatted_address,
                    type: scoreLocationType[candidate.geometry.location_type] == 100 ? 'point' : 'polygon',
                    category: category,
                    zipCode: null,
                    subRegion: null,
                    region: null,
                    location: {
                        lat: candidate.geometry.location.lat,
                        lng: candidate.geometry.location.lng
                    },
                    extent: {
                        xmin: candidate.geometry.viewport.southwest.lng,
                        ymin: candidate.geometry.viewport.southwest.lat,
                        xmax: candidate.geometry.viewport.northeast.lng,
                        ymax: candidate.geometry.viewport.northeast.lat
                    },
                    rank: index,
                    score: scoreLocationType[candidate.geometry.location_type]
                };

                const matchTypesProps = { 'administrative_area_level_1': 'region', 'administrative_area_level_2': 'subRegion', 'postal_code': 'zipCode' };

                candidate.address_components.map((component) => {
                    component.types.some((type) => {
                        if (matchTypesProps.hasOwnProperty(type)) {
                            result[matchTypesProps[type]] = component.long_name;
                            return true;
                        }
                        return false;
                    });
                });
                return result;
            }),
            spatialReference: { wkid: this.defaultProjection }
        };
    }
}

class GooglePlaceSearch extends BasePlaceSearch {
    getUrl(query) {
        const params = {
            query: query,
            key: this.config.token,      // [Required]: API key to authenticate the request
            location: null,              // [Optional]: Coordinates to search for nearby places     [ Example: location=37.7749,-122.4194 ]
            radius: null,                // [Optional]: Radius in meters to narrow the search       [ Example: radius = 1500 ]
            type: null,                  // [Optional]: Type of place to search                     [ Example: type=restaurant ] r(por ejemplo, restaurante, hospital).
            keyword: null,               // [Optional]: Keyword to filter results                   [ Example: keyword=pizza ]
            language: null,              // [Optional]: Language of the results                     [ Example: language=es ]
            fields: null,                // [Optional]: Specific details you want in the response   [ Example: fields=name,formatted_address,geometry ]
            // Agrega otros parámetros opcionales aquí, por ejemplo: radius, region, etc.
        };

        const baseUrl = "https://maps.googleapis.com/maps/api/place/textsearch/json";
        return `${baseUrl}?${new URLSearchParams(params).toString()}`;
    }

    processResult(data) {
        // Se asume que data.results contiene los lugares encontrados.
        return (data.results || []).map(place => ({
            name: place.name,
            address: place.formatted_address,
            location: {
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng,
            },
            place_id: place.place_id,
            rating: place.rating,
            // Puedes agregar más campos según tus necesidades.
        }));
    }
}

class EsriPlaceSearch extends BasePlaceSearch {

    constructor(config) {
        super(config);

        // translation of some types of elements
        this._attrType = {
            "Airport": "Aeroporto",
            "Auto Dealership": "Concessionário de automóveis",
            "Beach": "Praia",
            "City": "Cidade",
            "Clothing Store": "Loja de roupa",
            "County": "Concelho",
            "Fitness Center": "Centro de fitness",
            "Food and Beverage Shop": "Loja de alimentos e bebidas",
            "Garden": "Jardim",
            "Government Building": "Edifício governamental",
            "Historical Monument": "Monumento Histórico",
            "Historical Site": "Local histórico",
            "Hospital": "Hospital",
            "Hotel": "Hotel",
            "Industrial Zone": "Zona industrial",
            "Japanese Food": "Comida Japonesa",
            "Latin American Food": "Comida Latino-Americana",
            "Library": "Biblioteca",
            "Metro": "Metro",
            "Metro Station": "Estação de Metro",
            "Museum": "Museu",
            "Neighborhood": "Freguesia",
            "Park": "Parque",
            "Place of Worship": "Local de culto",
            "Portuguese Food": "Comida portuguesa",
            "Residential Area": "Área residencial",
            "Restaurant": "Restaurante",
            "School": "Escola",
            "Shopping Mall": "Centro comercial",
            "Specialty Store": "Loja Especializada",
            "Sports Center": "Centro Desportivo",
            "Sports Facility": "Instalação desportiva",
            "State or Province": "Estado ou Província",
            "Tourist Attraction": "Atração turística",
            "Train Station": "Estação de comboios"
        }

        this.defineApiParams = {
            f: { required: true, default: 'json' },           // [Required]: Response format, either json or pjson
            token: { required: true, default: null },         // [Required]: Access token with the required privileges
            SingleLine: null,                                 // [Optional]: Complete address in a single field  [ Example: SingleLine=1600+Amphitheater+Parkway,+Mountain+View,+CA ]
            address: null,                                    // [Optional]: First line of the address  [ Example: address=1600 Amphitheatre Parkway ]
            address2: null,                                   // [Optional]: The second line of a street address
            address3: null,                                   // [Optional]: The third line of a street address
            neighborhood: null,                               // [Optional]: A neighborhood; a subdivision of a city
            city: null,                                       // [​Optional]: A city or municipality  [ Example: city=Mountain View ]
            subregion: null,                                  // [​Optional]: A county  [ Example: city=Mountain View ]
            region: null,                                     // [Optional]: State or province  [ Example: region=CA ]
            postal: null,                                     // [Optional]: Standard postal code for an address  [ Example: postal=94043 ]
            postalExt: null,                                  // [Optional]: postal code extension
            countryCode: { default: 'PRT' },                  // [Optional]: Country code in ISO format  [ Example: countryCode = US ]
            magicKey: null,                                   // [Optional]: MagicKey value returned from a suggest request
            searchExtent: null,                               // [Optional]: Coordinates to limit the search area  [ Example: searchExtent=-122.5, 37.7,- 122.4,37.8 ]
            location: null,                                   // [Optional]: Point used to favor geocoding candidates based on their proximity to the location
            category: null,                                   // [Optional]: Place or address type that can be used to filter results
            outSR: null,                                      // [Optional]: Spatial reference of the x and y coordinates returned in a response
            outFields: null,                                  // [Optional]: List of fields to be returned within the attributes object of a response  [ Example: outFields=Match_addr,Addr_type ]
            maxLocations: 10,                                 // [Optional]: Maximum number of results [ Example: maxLocations=5]
            forStorage: null,                                 // [Optional]: Specifies whether the results of a request are stored 
            matchOutOfRange: null,                            // [Optional]: Returns a match when the input house number is outside the street's house number range
            locationType: null,                               // [Optional]: Specifies whether output geometry of PointAddress and Subaddress matches should be the rooftop point or street entrance
            langCode: { default: 'PRT' },                     // [Optional]: Language in which results are returned
            sourceCountry: null,                              // [Optional]: Limits the returned candidates to the specified country or countries
            preferredLabelValues: null                        // [Optional]: Returns the specified street or city name in output fields
        };
    }

    getUrl(query) {

        const sendParams = {};

        for (let key in this.config)
            if (this.config.hasOwnProperty(key) && this.config[key] != null && this.config[key] != undefined)
                sendParams[key] = this.config[key];

        sendParams['SingleLine'] = query;

        const baseUrl = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates";
        return `${baseUrl}?${new URLSearchParams(sendParams).toString()}`;
    }

    processResult(response) {
        return {
            candidates: (response.candidates || []).map(candidate => ({
                name: candidate.attributes.Address || candidate.address,    // at Esri, the address is the primary identifier
                address: candidate.address,
                type: candidate.attributes.Addr_type && candidate.attributes.Addr_type.toLowerCase() == 'poi' ? 'point' : 'polygon',
                category: candidate.attributes.Type ? (this._attrType[candidate.attributes.Type] ? this._attrType[candidate.attributes.Type] : candidate.attributes.Type) : '----',
                zipCode: candidate.attributes.Postal || null,
                subRegion: candidate.attributes.Subregion || null,
                region: candidate.attributes.Region || null,
                location: {
                    // at Esri, x is used for longitude and y for latitude
                    lat: candidate.location.y,
                    lng: candidate.location.x
                },
                extent: candidate.extent,
                rank: candidate.attributes.Rank,
                score: candidate.score       // match score
            })),
            spatialReference: response.spatialReference
        };
    }
}

class ErrorSearch extends Error {
    constructor(mensaje, codigo) {
        super(mensaje);
    }
}